import {observer} from "mobx-react";
import CheckboxFilter from "./CheckboxFilter";
import {useStore} from "../../../stores/Store";

export default observer(function NotesRightButtonFilter(){
    const {LanguageStore, AccordionStore} = useStore();
    const {currentLanguageMessages} = LanguageStore;
    const {filteredNotesRightBtn, setFilteredNotesRightBtn, findDistinctNotesRightBtns} = AccordionStore;

    const createCheckObjects = () => {
        const co: { value: number, label: string }[] = [];
        findDistinctNotesRightBtns().map(v => {
            if (v.buttonRight) co.push({
                value: v.buttonRight,
                label: `${v.buttonRight} (${v.buttonRangeRight} ${v.rangeRightFrom}/${v.rangeRightTo})`
            })
        });
        return co;
    }

    return (
        <CheckboxFilter
            title={currentLanguageMessages.AccordionsPage.Filter.RightHandButtons.title}
            filteredValue={filteredNotesRightBtn}
            setFilteredValue={setFilteredNotesRightBtn}
            checkObjects={createCheckObjects()}
            attributeName={'buttonRight'}
        />
    )
})